/* 司法确认详情 */
import Vue from 'vue';
import {genId, queryJudicialInfoByCaseId} from '@/assets/js/api';
import {amount_format_yuan, accMul} from '@/assets/js/utils';
import * as utils from '@/assets/js/utils';

const rule_evidence = {
  '54': {
    show: ['1', '2'],
    required: false
  },
  '51': {
    show: ['2'],
    required: false
  },
  '52': {
    show: ['2'],
    required: false
  },
  '53': {
    show: ['2'],
    required: false
  },
  '55': {
    show: ['2'],
    required: false
  },
  '99': {
    show: ['1', '2'],
    required: false
  },
};

export default {
  state: {
    bseId: '',
    rulesConfig: {},
    // 基础信息
    base: {},
    // 结案信息
    caseClosureInformation: {},
    audits: [],
    // 关联非诉调解信息
    caseJudicialConfirmationDto: {},
    naturalPersonOrPlaintiffList: [],
    // 材料
    evidenceFiles: [],
    materialFiles: [],
  },
  getters: {
    personList: (state) => {
      return state.naturalPersonOrPlaintiffList.reduce((result, item) => {
        const mediateAgents = item.mediateAgents || [];
        result.push(item);
        result = result.concat(mediateAgents);
        return result;
      }, []);
    },
    litigationFileObj: (state) => {
      return state.materialFiles.reduce((result, fileData) => {
        if (['74', '11', '12', '76'].includes(fileData.fileType)) {
          result[fileData.fileType] = fileData;
        }
        return result;
      }, {});
    },
    identificationFileObj: (state) => {
      return state.materialFiles.reduce((result, fileData) => {
        if (['2', '3', '7', '8', '20'].includes(fileData.fileType)) {
          if (!result[fileData.ownerId]) {
            result[fileData.ownerId] = {};
          }
          result[fileData.ownerId][fileData.fileType] = fileData;
        }
        return result;
      }, {});
    },
    agentFileObj: (state) => {
      return state.materialFiles.reduce((result, fileData) => {
        if (['4', '60', '5', '6'].includes(fileData.fileType)) {
          if (!result[fileData.ownerId]) {
            result[fileData.ownerId] = {};
          }
          result[fileData.ownerId][fileData.fileType] = fileData;
        }
        return result;
      }, {});
    },
    confirmationFileObj: (state) => {
      return state.materialFiles.reduce((result, fileData) => {
        if (['75'].includes(fileData.fileType)) {
          result[fileData.ownerId] = fileData;
        }
        return result;
      }, {});
    },
    yzw_params: (state) => {
      return {
        // 基础信息
        base: {
          ...state.base,
          bseQfkjzrq: accMul(Number(String(state.base.bseQfkjzrq).replace(/\,|\，/g, '')), 100)
        },
        caseJudicialConfirmationDto: {signTime: state.base.signTime},
        naturalPersonOrPlaintiffList: state.naturalPersonOrPlaintiffList,
        evidenceFiles: state.evidenceFiles.map(item => {
          return {
            caseId: state.base.bseId,
            ...item
          };
        }),
        materialFiles: state.materialFiles.map(item => {
          return {
            caseId: state.base.bseId,
            ...item
          };
        }),
      };
    },
  },
  mutations: {
    SET_YZW_BSE_ID: (state, bseId) => {
      state.bseId = bseId;
    },
    QUERY_YZW_JUDICIAL_INFO: (state, _data) => {
      state.audits = _data.audits || [];
      state.caseClosureInformation = _data.caseClosureInformation || {};
      state.caseJudicialConfirmationDto = _data.caseJudicialConfirmationDto || {};
      state.base = {
        ..._data.base,
        signTime: _data.caseJudicialConfirmationDto.signTime || '',
        bseQfkjzrq: amount_format_yuan(_data.base.bseQfkjzrq)
      };
      state.evidenceFiles = _data.evidenceFiles || [];
      state.materialFiles = _data.materialFiles || [];
      state.naturalPersonOrPlaintiffList = _data.naturalPersonOrPlaintiffList.map(item => {
        const mediateAgents = item.mediateAgents || [];
        const id = item.personId || item.pltId;
        const address = item.address || {};
        return {
          personName: '',
          idType: '',
          idNumber: '',
          encryption_idNumber: utils.encryptionIdNumber(item.idNumber),
          sex: '',
          age: '',
          mobileNo: '',
          encryption_mobileNo: utils.encryptionPhone(item.mobileNo),
          profession: '',
          unitName: '',
          email: '',
          domicileAddress: '',
          deliveryAddress: '',
          permanentAddress: '',

          currentAddress: '',
          pltUnit: '',
          pltLicenceType: '',
          pltLicenceNumber: '',
          pltUnitType: '',
          pltAddress: '',
          pltContactInfo: '',
          encryption_pltContactInfo: utils.encryptionIdNumber(item.pltContactInfo),
          pltLeaderName: '',
          pltLeaderIdType: '',
          pltLeaderIdNumber: '',
          encryption_pltLeaderIdNumber: utils.encryptionIdNumber(item.pltLeaderIdNumber),
          pltLeaderJob: '',
          pltLeaderPhone: '',
          encryption_pltLeaderPhone: utils.encryptionPhone(item.pltLeaderPhone),
          pltLeaderTelephone: '',
          extendFields: {isAppointDelivery: '', },
          ...item,
          address: {
            adsBseId: state.bseId,
            relatedUserId: id,
            adsName: '',
            adsPhone: '',
            adsAddress: '',
            adsContact: '',
            email: '',
            ...address
          },
          pltId: id,
          personId: id,
          mediateAgents: mediateAgents.map(mediateAgent => {
            const mediateAgentAddress = mediateAgent.address || {};
            return {
              agtType: '',
              agtName: '',
              agtIdType: '',
              agtIdNumber: '',
              encryption_agtIdNumber: utils.encryptionIdNumber(mediateAgent.agtIdNumber),
              agentSex: '',
              agtPhone: '',
              encryption_agtPhone: utils.encryptionPhone(mediateAgent.agtPhone),
              agtLawyerType: '',
              agtOffice: '',
              lawRegistrAddress: '',
              agtLicnumber: '',
              ...mediateAgent,
              address: {
                adsBseId: state.bseId,
                relatedUserId: mediateAgent.agtId,
                adsName: '',
                adsPhone: '',
                adsAddress: '',
                curAddress: '',
                email: '',
                adsContact: '',
                ...mediateAgentAddress
              },
            };
          }),
          nation: String(item.nation || ''),
          pltContactType: String(item.pltContactType || ''),
        };
      });
    },
    ADD_YZW_APPLICANT: (state, _data) => {
      state.naturalPersonOrPlaintiffList.push(_data);
    },
    DEL_YZW_APPLICANT: (state, index) => {
      state.naturalPersonOrPlaintiffList.splice(index, 1);
    },
    QUERY_YZW_RULES_CONFIG: (state, data) => {
      state.rulesConfig = data;
    },
    ENCRYPTION_YZW_DATA(state, isEncryption) {
      if (isEncryption) {
        state.naturalPersonOrPlaintiffList.forEach(item => {
          item.encryption_mobileNo = utils.encryptionPhone(item.mobileNo);
          item.encryption_idNumber = utils.encryptionIdNumber(item.idNumber);
          item.encryption_pltLeaderPhone = utils.encryptionPhone(item.pltLeaderPhone);
          item.encryption_pltLeaderIdNumber = utils.encryptionIdNumber(item.pltLeaderIdNumber);
          item.encryption_pltContactInfo = utils.encryptionIdNumber(item.pltContactInfo);
        });
      } else {
        state.naturalPersonOrPlaintiffList.forEach(item => {
          item.encryption_mobileNo = item.mobileNo;
          item.encryption_idNumber = item.idNumber;
          item.encryption_pltLeaderPhone = item.pltLeaderPhone;
          item.encryption_pltLeaderIdNumber = item.pltLeaderIdNumber;
          item.encryption_pltContactInfo = item.pltContactInfo;
        });
      }
    },
    UPDATE_MATERIAL_FILE(state, data) {
      state.materialFiles.push(data);
    },
    UPDATE_EVIDENCE_FILE(state, data) {
      state.evidenceFiles.push(data);
    },
    UPDATE_EVIDENCE_FILES(state, list) {
      state.evidenceFiles = state.evidenceFiles.concat(list);
    },
    DEL_MATERIAL_FILE(state, data) {
      state.materialFiles.forEach((item, index) => {
        if (item.saveId === data.saveId) {
          state.materialFiles.splice(index, 1);
        }
      });
    },
    DEL_EVIDENCE_FILE(state, data) {
      state.evidenceFiles.forEach((item, index) => {
        if (item.saveId === data.saveId) {
          state.evidenceFiles.splice(index, 1);
        }
      });
    },
  },
  actions: {
    QueryYZWRulesConfig({commit}) {
      commit('QUERY_YZW_RULES_CONFIG', {
        base: {bseQfkjzrq: {required: false, disabled: false},},
        // 申请人信息
        plaintiff: {
          disabled: false,
          personName: {required: true, disabled: false},
          idType: {required: true, disabled: false},
          idNumber: {required: true, disabled: false},
          age: {required: true, disabled: false},
          sex: {required: true, disabled: false},
          nation: {required: false, disabled: false},
          mobileNo: {required: true, disabled: false},
          profession: {required: false, disabled: false},
          unitName: {required: false, disabled: false},
          email: {required: false, disabled: false},
          domicileAddress: {required: false, disabled: false},
          deliveryAddress: {required: false, disabled: false},
          permanentAddress: {required: false, disabled: false},
          isAppointDelivery: {required: false, disabled: false},
          currentAddress: {required: true, disabled: false},
          pltUnit: {required: true, disabled: false},
          pltLicenceType: {required: true, disabled: false},
          pltLicenceNumber: {required: true, disabled: false},
          pltEnterpriseType: {required: false, disabled: false},
          pltAddress: {required: true, disabled: false},
          pltContactType: {required: true, disabled: false},
          pltContactInfo: {required: false, disabled: false},
          pltLeaderName: {required: true, disabled: false},
          pltLeaderIdType: {required: true, disabled: false},
          pltLeaderIdNumber: {required: true, disabled: false},
          pltLeaderJob: {required: false, disabled: false},
          pltLeaderPhone: {required: true, disabled: false},
          pltLeaderTelephone: {required: false, disabled: false},
        },
        // 代理人信息
        agent: {
          disabled: false,
          agtType: {required: true, disabled: false},
          agtName: {required: true, disabled: false},
          agtIdNumber: {required: true, disabled: false},
          agtPhone: {required: true, disabled: false},
          agtMail: {required: true, disabled: false},
          agtDeliveryAddress: {required: true, disabled: false},
          agtLawyerType: {required: false, disabled: false},
          agtOffice: {required: true, disabled: false},
          lawRegistrAddress: {required: false, disabled: false},
          agtLicnumber: {required: true, disabled: false},
          agentSex: {required: true, disabled: false},
          agtIdType: {required: true, disabled: false},
          address: {
            adsName: {required: true, disabled: false},
            adsPhone: {required: true, disabled: false},
            adsAddress: {required: true, disabled: false},
            adsContact: {required: false, disabled: false},
            email: {required: true, disabled: false},
            curAddress: {required: true, disabled: false},
          },
        },
        // 材料
        file: {canUpload: true, // 总的上传
        },
      });
    },
    QueryYZWJudicialInfo({
      commit, state
    }, bseId) {
      return new Promise((resolve, reject) => {
        commit('SET_YZW_BSE_ID', bseId);
        queryJudicialInfoByCaseId({caseId: bseId})
          .then(({
            code, data, msg
          }) => {
            if (code === 200) {
              commit('QUERY_YZW_JUDICIAL_INFO', data);
              resolve();
            } else {
              reject();
            }
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 添加申请人
    async AddYZWApplicant({
      commit, state
    }) {
      const bseId = state.bseId;
      const id = await genId();
      commit('ADD_YZW_APPLICANT', {
        pltId: id.data,
        personId: id.data,
        pltBseId: bseId,
        mediateId: bseId,
        type: '1',
        personName: '',
        idType: '',
        idNumber: '',
        encryption_idNumber: '',
        sex: '',
        age: '',
        nation: '',
        mobileNo: '',
        encryption_mobileNo: '',
        profession: '',
        unitName: '',
        email: '',
        domicileAddress: '',
        deliveryAddress: '',
        permanentAddress: '',
        currentAddress: '',
        pltUnit: '',
        pltLicenceType: '',
        pltLicenceNumber: '',
        pltUnitType: '',
        pltAddress: '',
        pltContactType: '',
        pltContactInfo: '',
        pltLeaderName: '',
        pltLeaderIdType: '',
        pltLeaderIdNumber: '',
        encryption_pltLeaderIdNumber: '',
        pltLeaderJob: '',
        pltLeaderPhone: '',
        encryption_pltContactInfo: '',
        encryption_pltLeaderPhone: '',
        pltLeaderTelephone: '',
        address: {
          adsBseId: bseId,
          relatedUserId: id.data,
          adsName: '',
          adsPhone: '',
          adsAddress: '',
          adsContact: '',
          email: '',
        },
        mediateAgents: [],
        extendFields: {isAppointDelivery: '', }
      });
    },
    // 删除申请人
    async DelYZWApplicant({commit}, data) {
      commit('DEL_YZW_APPLICANT', data);
    },
  }
};
